"use strict";

exports.__esModule = true;
exports.default = void 0;

var _collapse = _interopRequireDefault(require("./collapse"));

var _toggle = _interopRequireDefault(require("../../directives/toggle/toggle"));

var _plugins = require("../../utils/plugins");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var components = {
  BCollapse: _collapse.default
};
var directives = {
  BToggle: _toggle.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    components: components,
    directives: directives
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/collapse/index.js
// module id = 92
// module chunks = 0